import AvatarPortalDemoPoster from "../../../../../images/posters/avatar/walkthroughs/portal-walkthrough.webp";
import AvatarAppWalkthroughPoster from "../../../../../images/posters/avatar/walkthroughs/app-walkthrough.webp";

const avatarWalkthroughs = [
  {
    "title": "Avatar Nutrition Portal Walkthrough",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/Updated+Avatar+Nutrition+Portal+Demo+2025.mp4",
    "thumbnail": AvatarPortalDemoPoster,
    "length": "26:25",
    "starred": true,
    "timestamps": [
      {
        "title": "0:00 - Intro",
        "time": 0
      },
      {
        "title": "0:20 - Coaching Overview",
        "time": 20
      },
      {
        "title": "4:34 - Inspect Account",
        "time": 274
      },
      {
        "title": "7:51 - Edit Account",
        "time": 471
      },
      {
        "title": "11:07 - Templates",
        "time": 667
      },
      {
        "title": "14:20 - Campaigns",
        "time": 860
      },
      {
        "title": "15:59 - Team Management",
        "time": 959
      },
      {
        "title": "17:34 - Client Management",
        "time": 1054
      },
      {
        "title": "18:44 - Client Registration Flow",
        "time": 1124
      },
      {
        "title": "23:27 - Billing",
        "time": 1407
      },
      {
        "title": "25:05 - Why You Should Add Yourself and Your Team as Clients",
        "time": 1505
      },
      {
        "title": "26:08 - Conclusion",
        "time": 1568
      }
    ]
  },
  {
    "title": "Avatar Nutrition App Walkthrough",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/Avatar+App+Walkthrough.webm",
    "thumbnail": AvatarAppWalkthroughPoster,
    "length": "16:36",
    "starred": true,
    "objectFit": "contain",
    "timestamps": [
      {
        "title": "0:00 - Intro",
        "time": 0
      },
      {
        "title": "0:26 - How to use Avatar",
        "time": 26
      },
      {
        "title": "0:57 - Features that help you hit your macros",
        "time": 57
      },
      {
        "title": "1:37 - Daily macro adjustments",
        "time": 97
      },
      {
        "title": "2:14 - Edit balance tool (carb/fat swap)",
        "time": 134
      },
      {
        "title": "2:55 - Adding food",
        "time": 175
      },
      {
        "title": "3:45 - Suggested food list",
        "time": 225
      },
      {
        "title": "4:08 - Favorite items, meals, & days",
        "time": 248
      },
      {
        "title": "4:34 - Recipes",
        "time": 274
      },
      {
        "title": "4:56 - Preview macros",
        "time": 296
      },
      {
        "title": "5:21 - Recipe ingredient swaps",
        "time": 321
      },
      {
        "title": "5:56 - Recent items",
        "time": 356
      },
      {
        "title": "6:21 - Tracking alcohol",
        "time": 381
      },
      {
        "title": "6:57 - Multi-selecting items",
        "time": 417
      },
      {
        "title": "7:19 - Copying meals & days",
        "time": 439
      },
      {
        "title": "7:51 - Sharing food with friends",
        "time": 471
      },
      {
        "title": "8:38 - Drag & drop food",
        "time": 518
      },
      {
        "title": "9:00 - Check-ins",
        "time": 540
      },
      {
        "title": "10:28 - Macro adjustments",
        "time": 628
      },
      {
        "title": "10:51 - Check-in history",
        "time": 651
      },
      {
        "title": "11:12 - Editing a check-in",
        "time": 672
      },
      {
        "title": "11:37 - Progress photos",
        "time": 697
      },
      {
        "title": "12:05 - Coaching",
        "time": 725
      },
      {
        "title": "12:26 - Additional features",
        "time": 746
      },
      {
        "title": "12:35 - Edit macros & calories",
        "time": 755
      },
      {
        "title": "12:48 - Edit activity level",
        "time": 768
      },
      {
        "title": "13:19 - Advanced features",
        "time": 799
      },
      {
        "title": "13:43 - High/low days",
        "time": 823
      },
      {
        "title": "14:10 - Vacation mode",
        "time": 850
      },
      {
        "title": "14:32 - Daily weights",
        "time": 872
      },
      {
        "title": "15:00 - Body measurements",
        "time": 900
      },
      {
        "title": "15:27 - Intermittent fasting",
        "time": 927
      }
    ]
  }
];

export default avatarWalkthroughs; 